export function createDesign(scope: string) {
  return {
    prefixCls: scope,
  };
}
